
import React from 'react';
import { useResource, useRouterActions } from "react-resource-router";
import constants from "../../constants";
import { BreadCrumb } from 'primereact/breadcrumb';
import { useResourcesStore } from '../../store/ResourcesStore';

const BreadCrumbMenue = ({breadCrumb}) => {

  const { push } = useRouterActions();

  const [state, actions ] = useResourcesStore();

    return ( 
      <BreadCrumb model={ state.breadCrumbs } home={{ icon: 'pi pi-home', command: () => { push(constants.routes.dashboard); actions.onSelectPage([]) } }} />
    )
    
}
export default BreadCrumbMenue;